import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import _ from 'lodash';
import {
  Card,
  Row,
  Col,
  DatePicker,
  Select,
  Space,
  Statistic,
  Layout,
  Button,
  Dropdown,
  Spin,
  message,
  Table,
  Tabs,
  Tooltip,
  Badge,
  Modal
} from 'antd';

import styles from "./index.module.css";
import { fetchAllTransportOrganizations, fetchTCDrivers, resetDrivers } from '../../../store/transport_organizations';
import { fetchAllHealthOrganizations } from '../../../store/health_organizations';
import { getReportingRides } from '../../../store/rides';

import {
  DownloadOutlined,
  ReloadOutlined,
  FilePdfOutlined,

  FileExcelOutlined,

  CarOutlined,
  UserOutlined,

  InfoCircleOutlined,
  FilterOutlined,
  DashboardOutlined,
  TableOutlined,
  LineChartOutlined, HeatMapOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  TeamOutlined,

  WarningOutlined,
  StarFilled,
  StarOutlined
} from '@ant-design/icons';
import * as d3 from 'd3';

import * as XLSX from 'xlsx';

import dayjs from 'dayjs';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import { fetchRidesData, generateMockRides } from '../../../components/charts/mockRides/mockRides';
import classNames from 'classnames';
import { ReportsSection } from '../../../components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RIDE_STATUSES, VEHICLE_TYPES_LABEL } from '../../../constants/constants';
import { exportReport } from '../../../store/reports';
import RideRating from '../../../components/common/RideRating/RideRating';


dayjs.extend(customParseFormat);

// Custom D3 Charts
const StatusPieChart = React.lazy(() => import('../../../components/charts/StatusPieChart/StatusPieChart'));
const RidesByCountyChart = React.lazy(() => import('../../../components/charts/RidesByCountyChart/RidesByCountyChart'));
const MonthlyTrendChart = React.lazy(() => import('../../../components/charts/MonthlyTrendChart/MonthlyTrendChart'));
const DonutChartWithCenterTotal = React.lazy(() => import('../../../components/charts/donutChartWithCenterTotal/donutChartWithCenterTotal'));
const BarChart = React.lazy(() => import('../../../components/charts/barChart/barchart'));

const { Header, Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { TabPane } = Tabs;

const statusColors = {
  PENDING: '#faad14',
  ACCEPTED: '#1890ff',
  START: '#13c2c2',
  COMPLETED: '#52c41a',
  EXPIRED: '#f5222d',
  CANCELED: '#eb2f96',
  UNFULFILLED: '#722ed1'

};


const statusLabel = {
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  START: 'Start',
  COMPLETED: 'Completed',
  EXPIRED: 'Expired',
  CANCELED: 'Canceled',
  UNFULFILLED: 'Unable to Fulfill',
  IN_PROGRESS: 'In Progress',

};


const vehicleTypesColors = {
  ambulatoryRiderIsWalking: 'red',
  ambulatoryAssistRiderIsWalking: 'green',

  CANCELED: '#eb2f96',
  UNFULFILLED: '#722ed1'
};

const MH_Reporting_Dashboard = ({

  fetchAllTransportOrganizations,
  getReportingRides,
  fetchTCDrivers,
  resetDrivers,
  fetchAllHealthOrganizations,
  transportCompanies,
  drivers,
  ridesData,
  summary,
  exportReport,
  loading,
  healthOrganizations }

) => {

  const [dateRange, setDateRange] = useState([dayjs().subtract(3, 'month'), dayjs()]);
  const [selectedOrg, setSelectedOrg] = useState('all');
  const [selectedTransport, setSelectedTransport] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedVehicleType, setSelectedVehicleType] = useState('all');
  const [selectedDriver, setSelectedDriver] = useState('all');



  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [activeTab, setActiveTab] = useState('1');
  const [showFilters, setShowFilters] = useState(true);
  const [selectedRide, setSelectedRide] = useState(null);
  const [rideModalVisible, setRideModalVisible] = useState(false);


  const disabledDate = (current) => {
    if (!dateRange || dateRange.length === 0) {
      return false;
    }
    const [start, end] = dateRange;

    // Always allow selecting a new start date
    if (!start || !end) {
      return false;
    }

    // When both dates are selected, restrict only the end date to 90 days from start
    return (
      current && (current.isBefore(start, 'day') || current.isAfter(start.add(90, 'day'), 'day'))
    );
  };

  function stringToColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      color += ('00' + ((hash >> (i * 8)) & 0xFF).toString(16)).slice(-2);
    }
    return color;
  }

  const rideDistanceCategories = [
    { key: 'urban', label: 'Urban (≤ 50 miles)' },
    { key: 'subUrban', label: 'Suburban (51-75 miles)' },
    { key: 'rural', label: 'Rural (> 75 miles)' },
  ];

  const rideReschduleCancellation = [
    { key: 'RESCHEDULED', label: 'Rescheduled Rides' },
    { key: 'CANCELED', label: 'Canceled' },
    { key: 'RESCHEDULED_CANCELED', label: 'Reschedule & Canceled' },
  ];

  const TcStatus = [
    { key: 'COMPLETED', label: 'Completed' },
    { key: 'OTHER', label: 'Other' },

  ];

  const rideStatuses = [
    { key: 'rides', label: 'All Rides', color: statusColors.ACCEPTED },
    { key: 'COMPLETED', label: 'Completed', color: statusColors.COMPLETED },
    { key: 'PENDING', label: 'Pending', color: statusColors.PENDING },
    { key: 'EXPIRED', label: 'Expired', color: statusColors.EXPIRED },

    { key: 'UNABLE_TO_FULFILL', label: 'Unable to Fulfill', color: statusColors.UNFULFILLED },

  ]
  // Star rating component
  const renderStarRating = (score) => {
    const fullStars = Math.floor(score);
    const hasHalfStar = score % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <div>
        {[...Array(fullStars)].map((_, i) => (
          <StarFilled key={`full-${i}`} style={{ color: '#ffc53d', fontSize: 20 }} />
        ))}
        {hasHalfStar && (
          <StarFilled key="half" style={{ color: '#ffc53d', fontSize: 20, opacity: 0.5 }} />
        )}
        {[...Array(emptyStars)].map((_, i) => (
          <StarOutlined key={`empty-${i}`} style={{ color: '#ffc53d', fontSize: 20 }} />
        ))}
      </div>
    );
  };


  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    fetchAllTransportOrganizations();
    fetchAllHealthOrganizations();

    return () => { };
  }, [fetchAllTransportOrganizations, fetchAllHealthOrganizations]);


  useEffect(() => {
    if (selectedTransport && selectedTransport !== 'all') {
      // Call fetchTCDrivers when a valid transport company is selected
      fetchTCDrivers(selectedTransport);
    } else {
      // Reset drivers if no transport company is selected
      resetDrivers();
    }

    // Reset the selected driver to 'all' whenever the transport company changes
    setSelectedDriver('all');
  }, [selectedTransport, fetchTCDrivers, resetDrivers]);

  // Fetch reference data (orgs, transport companies, drivers)
  const fetchReferenceData = useCallback(async () => {
    try {
      // In a real app, these would be API calls


      // const mockDrivers = [
      //   { id: 'driver1', name: 'John Smith' },
      //   { id: 'driver2', name: 'Maria Garcia' },
      //   { id: 'driver3', name: 'David Johnson' }
      // ];


      // setDrivers(mockDrivers);
    } catch (error) {
      message.error('Failed to load reference data');
      console.error('Error loading reference data:', error);
    }
  }, []);

  // Fetch rides data from API
  const fetchData = useCallback(async () => {

    try {
      if (!dateRange || dateRange.length !== 2) {
        //message.error('Please select a valid date range');
        return;
      }
      const data = await getReportingRides({
        startDate: dateRange[0].format('YYYY-MM-DD'),
        endDate: dateRange[1].format('YYYY-MM-DD'),
        healthOrganizationId: selectedOrg !== 'all' ? selectedOrg : undefined,
        transportCompanyId: selectedTransport !== 'all' ? selectedTransport : undefined,
        status: selectedStatus !== 'all' ? selectedStatus : undefined,
        vehicleType: selectedVehicleType !== 'all' ? selectedVehicleType : undefined,
        driverId: selectedDriver !== 'all' ? selectedDriver : undefined
      });


    } catch (error) {
      message.error('Failed to fetch ride data');
      console.error('Error fetching ride data:', error);
    } finally {

    }
  }, [dateRange, selectedOrg, selectedTransport, selectedStatus, selectedVehicleType, selectedDriver]);

  // Initial data load
  useEffect(() => {
    fetchReferenceData();
    fetchData();
  }, [fetchReferenceData, fetchData]);

  // Processed data for charts
  const processedData = useMemo(() => {
    if (!ridesData || ridesData.length === 0) {
      return {
        statusCounts: {},
        monthlyTrends: [],
        orgPerformance: [],
        transportPerformance: [],
        driverPerformance: [],
        vehicleTypeCounts: {},
        counties: [],
        hoActivityCounts: {},
        cancellationData: {},
        monthlyPatientTrends: [],
        recurrenceAnalysis: {},
        timeMetrics: {
          avgResponseTime: 'N/A',
          avgLoadTime: 'N/A',
          avgRideDuration: 'N/A',
          avgWaitTime: 'N/A',
          avgMileage: 'N/A'
        },
        rawData: []
      };
    }


    // Status distribution
    const statusCounts = ridesData.reduce((acc, ride) => {
      acc[ride.status] = (acc[ride.status] || 0) + 1;

      return acc;
    }, {});


    // Vehicle type distribution
    const vehicleTypeCounts = ridesData.reduce((acc, ride) => {
      const type = ride.vehicleType || 'Unknown';
      acc[type] = (acc[type] || 0) + 1;
      return acc;
    }, {});

    // Extract county from pickup address (assuming format like "123 Main St, King County")
    const countyData = ridesData.reduce((acc, ride) => {
      const countyMatch = ride.pickupAddressDetails.county;
      const county = countyMatch ? countyMatch.trim() : 'Unknown';
      acc[county] = (acc[county] || 0) + 1;
      return acc;
    }, {});

    const counties = Object.entries(countyData)
      .map(([county, count]) => ({ county, count }))
      .sort((a, b) => b.count - a.count);


    const hoActivityCounts = getHOActivityCount(ridesData, 'createdBy');



    // Monthly trends
    const monthlyTrends = ridesData.reduce((acc, ride) => {
      const month = dayjs(ride.pickUpDate).format('MMM YYYY');
      if (!acc[month]) {
        acc[month] = {
          month,
          rides: 0,
          COMPLETED: 0,
          PENDING: 0,
          EXPIRED: 0,
          UNABLE_TO_FULFILL: 0,
          RESCHEDULED: 0,
          CANCELED: 0,
          RESCHEDULED_CANCELED: 0,

        };
      }
      acc[month].rides++;

      if (ride.isRescheduled === true) acc[month].RESCHEDULED++;
      if (ride.isRescheduled === true && ride.status === RIDE_STATUSES.CANCELED) acc[month].RESCHEDULED_CANCELED++;
      if (ride.status === RIDE_STATUSES.CANCELED) acc[month].CANCELED++;
      if (ride.status === RIDE_STATUSES.COMPLETED) acc[month].COMPLETED++;
      if (ride.status === RIDE_STATUSES.PENDING) acc[month].PENDING++;
      if (ride.status === RIDE_STATUSES.EXPIRED) acc[month].EXPIRED++;
      if (ride.status === RIDE_STATUSES.UNABLE_TO_FULFILL) acc[month].UNABLE_TO_FULFILL++;


      return acc;
    }, {});



    // Organization performance
    const orgPerformance = ridesData.reduce((acc, ride) => {
      const orgId = ride.healthOrganizationId;
      const orgName = healthOrganizations.find(o => o.id === orgId)?.name || `Org ${orgId}`;

      if (!acc[orgId]) {
        acc[orgId] = {
          org: orgName,
          COMPLETED: 0,
          FAILED: 0,
          PENDING: 0,
          EXPIRED: 0,
          CANCELED: 0,
          UNABLE_TO_FULFILL: 0
        };
      }
      if (ride.status === RIDE_STATUSES.COMPLETED) acc[orgId].COMPLETED++;
      if (ride.status === RIDE_STATUSES.CANCELED) acc[orgId].CANCELED++;
      if (ride.status === RIDE_STATUSES.EXPIRED) acc[orgId].EXPIRED++;
      if (ride.status === RIDE_STATUSES.UNFULFILLED) acc[orgId].UNABLE_TO_FULFILL++;
      if (ride.status === RIDE_STATUSES.PENDING) acc[orgId].PENDING++;
      return acc;
    }, {});

    // Transport company performance
    const transportPerformance = ridesData.reduce((acc, ride) => {
      const tcId = ride.transportCompanyId;
      const tcName = transportCompanies.find(t => t.id === tcId)?.name || `Co. ${tcId}`;

      if (!acc[tcId]) {
        acc[tcId] = {
          company: tcName,
          COMPLETED: 0,
          OTHER: 0,
          PENDING: 0,
          avgResponseTime: 0,
          responseTimeCount: 0
        };
      }
      if (ride.status === RIDE_STATUSES.COMPLETED) acc[tcId].COMPLETED++;
      if ([RIDE_STATUSES.EXPIRED, RIDE_STATUSES.UNABLE_TO_FULFILL].includes(ride.status)) acc[tcId].OTHER++;
      if (ride.status === RIDE_STATUSES.PENDING) acc[tcId].PENDING++;

      // Calculate response time metrics
      if (ride.acceptanceTime && ride.createdAt) {
        const responseMs = new Date(ride.acceptanceTime) - new Date(ride.createdAt);
        acc[tcId].avgResponseTime += responseMs;
        acc[tcId].responseTimeCount++;
      }
      return acc;
    }, {});

    // Calculate average response times
    Object.values(transportPerformance).forEach(tc => {
      if (tc.responseTimeCount > 0) {
        tc.avgResponseTime = formatDuration(tc.avgResponseTime / tc.responseTimeCount);
      } else {
        tc.avgResponseTime = 'N/A';
      }
    });

    // Driver performance
    const driverPerformance = ridesData.reduce((acc, ride) => {
      if (!ride.driverId) return acc;

      const driverId = ride.driverId;
      // console.log('Driver ID:', driverId);
      // console.log('Driver Name:', drivers);
      // const driverName = drivers.find(d => d.id === driverId)?.name || `Driver ${driverId}`;

      if (!acc[driverId]) {
        acc[driverId] = {
          driver: ride.driverName,
          COMPLETED: 0,
          FAILED: 0,
          avgRating: 0,
          ratingCount: 0,
          totalMiles: 0
        };
      }
      if (ride.status === RIDE_STATUSES.COMPLETED) acc[driverId].COMPLETED++;
      if ([RIDE_STATUSES.EXPIRED, RIDE_STATUSES.UNABLE_TO_FULFILL].includes(ride.status)) acc[driverId].failed++;

      // Calculate driver metrics (assuming we have rating and mileage data)
      if (ride.driverRating) {
        acc[driverId].avgRating += ride.driverRating;
        acc[driverId].ratingCount++;
      }
      if (ride.actMileage) {
        acc[driverId].totalMiles += parseFloat(ride.actMileage) || 0;
      }
      return acc;
    }, {});

    // Calculate average ratings
    Object.values(driverPerformance).forEach(driver => {
      if (driver.ratingCount > 0) {
        driver.avgRating = (driver.avgRating / driver.ratingCount).toFixed(1);
      } else {
        driver.avgRating = 'N/A';
      }
    });



    // Recurrence analysis
    const recurrenceAnalysis = ridesData.reduce((acc, ride) => {
      const key = ride.isRecurring ? 'Recurring' : 'One-time';
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});

    // Time metrics
    const timeMetrics = {
      avgResponseTime: calculateAverageTime(ridesData, 'acceptanceTime', 'createdAt'),
      avgLoadTime: calculateAverageTime(ridesData, 'loadTime', 'acceptanceTime'),
      avgRideDuration: calculateAverageTime(ridesData, 'unloadTime', 'loadTime'),
      avgWaitTime: calculateAverageWaitTime(ridesData),
      avgMileage: calculateAverageMileage(ridesData)
    };

    const monthlyTrendsData = Object.values(monthlyTrends).sort((a, b) =>
      dayjs(a.month, 'MMM YYYY').diff(dayjs(b.month, 'MMM YYYY')))




    // Calculate no-shows (assuming status indicates no-shows)
    const noShowsCount = summary?.noShowCancellations?.count;
    const noShowRatio = summary?.noShowCancellations?.ratio || 0;
    // Calculate satisfaction (mock data - replace with actual)
    const satisfactionScore = summary?.satisfactionScore || 0; // Average from your data
    const satisfactionResponses = summary?.satisfactionResponses || 0; // Total ratings from your data


    console.log('info', summary);
    // ... existing data ...
    const uniqueMembers = {
      totalMembers: summary?.memberServedCount,// Object.values(memberMap).reduce((sum, count) => sum + count, 0),
      uniqueCount: summary?.uniquePatientCount,
    }

    // Calculate monthly trends for different patient types
    const monthlyPatientTrends = getMonthlyPatientTrends(ridesData);
    const monthlyPatientTrendsData = Object.values(monthlyPatientTrends).sort((a, b) =>
      dayjs(a.month, 'MMM YYYY').diff(dayjs(b.month, 'MMM YYYY')))





    const cancellationData = processCancellationData(ridesData);

    return {
      statusCounts,
      monthlyTrends: monthlyTrendsData,
      orgPerformance: Object.values(orgPerformance),
      transportPerformance: Object.values(transportPerformance),
      driverPerformance: Object.values(driverPerformance),
      counties: counties,
      vehicleTypeCounts,
      recurrenceAnalysis,
      hoActivityCounts,
      cancellationData,
      noShowsCount,
      noShowRatio,
      uniqueMembers,
      satisfactionScore,
      satisfactionResponses,
      rawData: ridesData,
      monthlyPatientTrends: monthlyPatientTrendsData

    };
  }, [ridesData, healthOrganizations, transportCompanies, drivers]);




  function getHOActivityCount(ridesData, property = 'createdBy') {
    const result = {};
    ridesData.forEach(ride => {
      const user = ride[property];
      if (user && user.firstName && user.lastName) {
        const key = `${user.firstName} ${user.lastName}`;
        result[key] = (result[key] || 0) + 1;
      }
    });
    return result;
  }


  function getMonthlyPatientTrends(ridesData) {
    return ridesData.reduce((acc, ride) => {
      const month = dayjs(ride.pickUpDate).format('MMM YYYY');
      if (!acc[month]) {
        acc[month] = {
          month,
          allPatients: 0,
          specialAccommodations: 0,
          riderNoShow: 0,
          frequentScheduled: 0,
          urban: 0,
          subUrban: 0,
          rural: 0
        };
      }

      acc[month].allPatients++;

      if (ride.riderInfo?.specialAccommodations) {
        acc[month].specialAccommodations++;
      }

      // if (ride.riderInfo?.specialAccommodations) {
      //   acc[month].specialAccommodations++;
      // }


      if (ride.riderInfo?.frequentFlyer) {
        acc[month].frequentScheduled++;
      }

      // Determine frequently scheduled (example: 3+ rides in same month)
      // const riderMonthlyRides = ridesData.filter(r =>
      //   r.riderInfoId === ride.riderInfoId &&
      //   dayjs(r.pickUpDate).format('MMM YYYY') === month
      // ).length;

      // if (riderMonthlyRides >= 3) {
      //   acc[month].frequentScheduled++;
      // }

      const riderNoShow = getRiderNoShowCancellationsByMonth(ridesData, month);
      const rideTypeCounts = getUrbanSuburbanRuralCountsByMonth(ridesData, month);

      acc[month].urban = rideTypeCounts?.urban || 0;
      acc[month].subUrban = rideTypeCounts?.subUrban || 0;
      acc[month].rural = rideTypeCounts?.rural || 0;
      acc[month].riderNoShow = riderNoShow.length;



      return acc;
    }, {});
  }



  function processCancellationData(ridesData) {
    // Filter only canceled rides
    const canceledRides = ridesData.filter(ride =>
      ride.status === 'CANCELED' && ride.cancellationInfo
    );

    // Group by canceledBy and then by cancellationReason
    const cancellationData = d3.rollups(
      canceledRides,
      v => d3.rollups(v, vs => vs.length, d => d.cancellationInfo.cancellationReason),
      d => d.cancellationInfo.canceledBy
    );

    // Convert to format needed for donut charts
    const result = {};
    cancellationData.forEach(([canceledBy, reasons]) => {
      result[canceledBy] = reasons.map(([reason, count]) => ({
        reason,
        count
      }));
    });

    // Ensure all categories exist (even if empty)
    const allCategories = ['HO_ADMIN', 'TC_ADMIN', 'DRIVER', 'RIDER', 'MH_ADMIN'];
    allCategories.forEach(cat => {
      if (!result[cat]) {
        result[cat] = [];
      }
    });

    return result;
  };
  function getUrbanSuburbanRuralCountsByMonth(ridesData, month) {
    const result = {
      urban: 0,
      subUrban: 0,
      rural: 0,
    };

    ridesData.forEach(ride => {
      if (
        ride.status === 'COMPLETED' &&
        dayjs(ride.pickUpDate).format('MMM YYYY') === month
      ) {
        if (ride.actMileage <= 50) {
          result.urban += 1;
        } else if (ride.actMileage <= 75) {
          result.subUrban += 1;
        } else if (ride.actMileage > 75) {
          result.rural += 1;
        }
      }
    });

    return result;
  }
  function getRiderNoShowCancellationsByMonth(ridesData, month) {
    return ridesData.filter(
      r =>
        r?.status === 'CANCELED' &&
        r?.cancellationInfo?.cancellationType === 'riderNoShow' &&
        dayjs(r.pickUpDate).format('MMM YYYY') === month
    );
  }




  // Helper function to calculate average time between two timestamps
  function calculateAverageTime(rides, endField, startField) {
    const validRides = rides.filter(ride => ride[endField] && ride[startField]);
    if (validRides.length === 0) return 'N/A';

    const totalMs = validRides.reduce((sum, ride) => {
      return sum + (new Date(ride[endField]) - new Date(ride[startField]));
    }, 0);

    const avgMs = totalMs / validRides.length;
    return formatDuration(avgMs);
  }

  // Helper function to calculate average wait time
  function calculateAverageWaitTime(rides) {
    const validRides = rides.filter(ride => ride.waitTime);
    if (validRides.length === 0) return 'N/A';

    const totalMinutes = validRides.reduce((sum, ride) => sum + parseInt(ride.waitTime || 0), 0);
    const avgMinutes = totalMinutes / validRides.length;
    return `${Math.round(avgMinutes)} mins`;
  }

  // Helper function to calculate average mileage
  function calculateAverageMileage(rides) {
    const validRides = rides.filter(ride => ride.actMileage);
    if (validRides.length === 0) return 'N/A';

    const totalMiles = validRides.reduce((sum, ride) => sum + parseFloat(ride.actMileage || 0), 0);
    const avgMiles = totalMiles / validRides.length;
    return `${avgMiles.toFixed(1)} miles`;
  }

  // Format duration in milliseconds to human-readable format
  function formatDuration(ms) {
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);

    if (hours > 0) return `${hours} hrs ${minutes % 60} mins`;
    if (minutes > 0) return `${minutes} mins`;
    return `${seconds} secs`;
  }




  const exportExcel = () => {
    if (!processedData) return;

    try {
      const workbook = XLSX.utils.book_new();




      // Raw data sheet
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(ridesData),
        'Raw Ride Data'
      );

      // Status counts sheet
      const statusData = Object.entries(processedData.statusCounts).map(([status, count]) => ({
        Status: status,
        Count: count,
        Percentage: `${((count / ridesData.length) * 100).toFixed(1)}%`
      }));
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(statusData),
        'Status Distribution'
      );

      // Monthly trends sheet
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(processedData.monthlyTrends),
        'Monthly Trends'
      );

      // Organization performance sheet
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(processedData.orgPerformance),
        'Org Performance'
      );

      XLSX.writeFile(workbook, `ride-data-${dayjs().format('YYYY-MM-DD')}.xlsx`);
      message.success('Data exported as Excel');
    } catch (error) {
      message.error('Failed to export Excel');
      console.error('Excel export error:', error);
    }
  };

  const exportMenuItems = [
    // {
    //   key: 'pdf',
    //   label: 'PDF Report',
    //   icon: <FilePdfOutlined />,
    //   onClick: exportPDF
    // },
    // {
    //   key: 'png',
    //   label: 'PNG Images',
    //   icon: <FileImageOutlined />,
    //   onClick: exportPNG
    // },
    // {
    //   key: 'jpeg',
    //   label: 'JPEG Images',
    //   icon: <FileImageOutlined />,
    //   onClick: exportJPEG
    // },
    // {
    //   key: 'excel',
    //   label: 'Excel Data',
    //   icon: <FileExcelOutlined />,
    //   onClick: exportExcel
    // }
  ];

  // Calculate chart dimensions based on window size
  const getChartDimensions = () => {
    if (windowSize.width < 768) {
      return { width: windowSize.width - 48, height: 300 };
    } else if (windowSize.width < 992) {
      return { width: (windowSize.width - 72) / 2, height: 350 };
    } else {
      return { width: (windowSize.width - 396) / 2, height: 400 };
    }
  };

  const chartDimensions = getChartDimensions();

  // Status optionsa
  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'PENDING', label: 'Pending' },
    { value: 'CANCELED', label: 'Canceled' },
    { value: 'ACCEPTED', label: 'Accepted' },
    { value: 'STARTED', label: 'Started' },
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'EXPIRED', label: 'Expired' },
    { value: 'UNABLE_TO_FULFILL', label: 'Unable to fullfill' }
  ];

  // Vehicle type options (extracted from data)
  const vehicleTypeOptions = useMemo(() => {
    if (!ridesData || ridesData.length === 0) return [{ value: 'all', label: 'All Types' }];

    const types = new Set();
    ridesData.forEach(ride => {
      if (ride.vehicleType) types.add(ride.vehicleType);
    });

    return [
      { value: 'all', label: 'All Types' },
      ...Array.from(types).map(type => ({
        value: type,
        label: type
      }))
    ];
  }, [ridesData]);

  // Driver options
  const driverOptions = useMemo(() => {
    return [
      { value: 'all', label: 'All Drivers' },
      ...drivers.map(driver => ({
        value: driver.id,
        label: driver.name
      }))
    ];
  }, [drivers]);

  // Show ride details modal
  const showRideDetails = (ride) => {
    setSelectedRide(ride);
    setRideModalVisible(true);
  };

  // if (!processedData) {
  //   return (
  //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
  //       <Spin size="large" tip="Loading dashboard..." />
  //     </div>
  //   );
  // }

  return (
    <Layout className="dashboard-layout" >
      <Header style={{
        background: '#fff',
        padding: '0 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.09)',
        position: 'sticky',
        top: 0,
        zIndex: 1
      }}>
        <Space>
          <DashboardOutlined style={{ fontSize: 24, color: 'var(--ant-primary-color)' }} />
          <h2 style={{ margin: 0 }}>MedHaul Insights</h2>
        </Space>
        <Space>
          <Tooltip title="Toggle filters">
            <Button
              className={classNames({
                [styles.btn]: true,
                [styles.customBtn]: true,

              })}
              icon={<FilterOutlined />}
              onClick={() => setShowFilters(!showFilters)}
              type={showFilters ? 'primary' : 'default'}
            />
          </Tooltip>
          {/* <Button
            className={classNames({
              [styles.btn]: true,
              [styles.customBtn]: true,

            })}
            icon={<ReloadOutlined />}
            onClick={fetchData}
            disabled={!dateRange || dateRange.length !== 2 || !dateRange[0] || !dateRange[1]}
          >
            Refresh
          </Button> */}
          {/* <Dropdown menu={{ items: exportMenuItems }} trigger={['click']}>
            <Button className={classNames({
              [styles.btn]: true,
              [styles.customBtn]: true,

            })} type="primary" icon={<DownloadOutlined />}>
              Export
            </Button>
          </Dropdown> */}
        </Space>
      </Header>

      <Content style={{ margin: '24px' }}>
        {/* Filters */}
        {showFilters && (
          <Card
            style={{ marginBottom: 24 }}
            // loading={loading}
            title={
              <Space>
                <FilterOutlined />
                <span>Filters</span>
              </Space>
            }
            extra={
              <Button
                className={classNames({
                  [styles.btn]: true,
                  [styles.customBtn]: true,

                })}
                type="primary"
                onClick={() => setDateRange([])}
                size="small"
                disabled={!dateRange}
              >
                Reset Dates
              </Button>
            }
          >
            <Space size="large" wrap style={{ width: '100%' }}>
              <RangePicker
                value={dateRange}
                onChange={setDateRange}
                disabledDate={disabledDate}
                style={{ width: '100%', maxWidth: 300 }}
                allowClear={true}
                presets={[
                  { label: 'Last 7 Days', value: [dayjs().subtract(7, 'days'), dayjs()] },
                  { label: 'Last 30 Days', value: [dayjs().subtract(30, 'days'), dayjs()] },
                  { label: 'Last 90 Days', value: [dayjs().subtract(90, 'days'), dayjs()] },
                  { label: 'This Month', value: [dayjs().startOf('month'), dayjs().endOf('month')] },
                ]}
              />
              {/* <Button
                onClick={() => setDateRange([])}
                style={{ marginLeft: 8 }}
              >
                Reset Dates
              </Button> */}
              <Select
                placeholder="Select Health Organization"
                style={{ width: 250 }}
                value={selectedOrg}
                onChange={setSelectedOrg}
                suffixIcon={<UserOutlined />}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
              >
                <Option value="all">All Organizations</Option>
                {healthOrganizations.map(org => (
                  <Option key={org.id} value={org.id}>{org.name}</Option>
                ))}
              </Select>
              <Select
                placeholder="Select Transport Company"
                style={{ width: 250 }}
                value={selectedTransport}
                onChange={setSelectedTransport}
                suffixIcon={<CarOutlined />}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
              >
                <Option value="all">All Companies</Option>
                {transportCompanies.map(tc => (
                  <Option key={tc.id} value={tc.id}>{tc.name}</Option>
                ))}
              </Select>
              {/* <Select
                placeholder="Select Status"
                style={{ width: 200 }}
                value={selectedStatus}
                onChange={setSelectedStatus}
                options={statusOptions}
              />
              <Select
                placeholder="Select Vehicle Type"
                style={{ width: 200 }}
                value={selectedVehicleType}
                onChange={setSelectedVehicleType}
                options={vehicleTypeOptions}
              />
              <Select
                placeholder="Select Driver"
                style={{ width: 200 }}
                value={selectedDriver}
                onChange={setSelectedDriver}
                options={driverOptions}
                disabled={drivers.length === 0}
              /> */}
            </Space>
          </Card>
        )}

        {/* Key Metrics */}

        {/* Key Metrics */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          {/* Rides Completed */}
          <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: windowSize.width < 768 ? 16 : 0 }}>
            <Card style={{ height: '100%' }}>


              <Statistic
                className={styles.statisticFixed}
                title="Rides Completed"
                value={processedData?.statusCounts.COMPLETED || 0}
                prefix={<CheckCircleOutlined style={{ color: '#52c41a', fontSize: 24 }} />}
                valueStyle={{
                  color: '#52c41a',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  flexWrap: 'wrap',              // Adds small spacing between icon and value
                }}
                suffix={
                  <span className={styles.summaryPercentage}>
                    {ridesData.length > 0
                      ? `${Math.round((processedData.statusCounts.COMPLETED / ridesData.length) * 100)}% completion rate`
                      : 'No rides data'
                    }
                  </span>
                }
              />



            </Card>
          </Col>

          {/* Rides Canceled */}
          <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: windowSize.width < 768 ? 16 : 0 }}>
            <Card style={{ height: '100%' }}>


              <Statistic
                className={styles.statisticFixed}
                title="Rides Canceled"
                value={(processedData?.statusCounts.Expired || 0) + (processedData?.statusCounts.CANCELED || 0)}
                prefix={<CloseCircleOutlined style={{ color: '#f5222d', fontSize: 24 }} />}
                valueStyle={{
                  color: '#f5222d',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  flexWrap: 'wrap',             // Adds small spacing between icon and value
                }}
                suffix={
                  <span className={styles.summaryPercentage}>
                    {ridesData.length > 0 ?
                      `${Math.round(((processedData.statusCounts.CANCELED) / ridesData.length) * 100)}% cancellation rate` :
                      'No rides data'}
                  </span>
                }
              />



            </Card>
          </Col>

          {/* Total Members Served */}
          <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: windowSize.width < 768 ? 16 : 0 }}>
            <Card style={{ height: '100%' }}>
              <Statistic
                className={styles.statisticFixed}
                title="Total Members Served"
                value={processedData?.uniqueMembers?.totalMembers || 0}
                prefix={<TeamOutlined style={{ color: '#1890ff', fontSize: 24 }} />}
                valueStyle={{
                  color: '#1890ff',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  flexWrap: 'wrap',               // Adds small spacing between icon and value
                }}
                suffix={
                  <span className={styles.summaryPercentage}>
                    Across all rides
                  </span>
                }
              />

            </Card>
          </Col>

          {/* Unique Members Served */}
          <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: windowSize.width < 900 ? 16 : 0 }}>
            <Card style={{ height: '100%' }}>
              <Statistic
                className={styles.statisticFixed}
                title="Unique Members Served"
                value={processedData?.uniqueMembers?.uniqueCount || 0}
                prefix={<UserOutlined style={{ color: '#722ed1', fontSize: 24 }} />}
                valueStyle={{
                  color: '#722ed1',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  flexWrap: 'wrap',              // Adds small spacing between icon and value
                }}
                suffix={
                  <span className={styles.summaryPercentage}>
                    {processedData?.uniqueMembers?.totalMembers > 0 ? (
                      `${Math.round((processedData.uniqueMembers.uniqueCount / processedData.uniqueMembers.totalMembers) * 100)}% of total`
                    ) : 'No member data'}
                  </span>
                }
              />

            </Card>
          </Col>

          {/* Rider No-Shows */}
          <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: windowSize.width < 768 ? 16 : 0 }}>
            <Card style={{ height: '100%' }}>
              <Statistic
                className={styles.statisticFixed}
                title="Rider No-Shows"
                value={processedData?.noShowsCount || 0}
                prefix={<WarningOutlined style={{ color: '#faad14', fontSize: 24 }} />}
                valueStyle={{
                  color: '#faad14',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  flexWrap: 'wrap',              // Adds small spacing between icon and value
                }}
                suffix={
                  <span className={styles.summaryPercentage}>
                    {ridesData.length > 0 ? (
                      `${processedData?.noShowRatio}% no-show rate`
                    ) : 'No rides data'}
                  </span>
                }

              />

            </Card>
          </Col>

          {/* Member Satisfaction Score */}
          <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: windowSize.width < 768 ? 16 : 0 }}>
            <Card style={{ height: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontSize: 14, color: 'rgba(0, 0, 0, 0.45)' }}>Member Satisfaction</div>

                  {selectedOrg !== 'all' && (
                    <div style={{ fontSize: 24, fontWeight: 500, margin: '4px 0' }}>
                      {processedData?.satisfactionScore?.toFixed(1) || '0.0'}
                      <span style={{ fontSize: 16, color: 'rgba(0, 0, 0, 0.45)', marginLeft: 4 }}>/5</span>
                    </div>
                  )}

                  {selectedOrg === 'all' && (
                    <div style={{ fontSize: 13, color: '#474747', margin: '6px 0 0' }}>
                      Select an organization to view score
                    </div>
                  )}

                </div>
                
                {selectedOrg !== 'all' && (
                  <div>
                    {renderStarRating(processedData?.satisfactionScore || 0)}
                    
                  </div>
                )}
              </div>

              {selectedOrg !== 'all' && (
                <div style={{ marginTop: 8, fontSize: 12 }}>
                  Based on {processedData?.satisfactionResponses || 0} ratings
                </div>
              )}
            </Card>
          </Col>
          
        </Row>
        {/* Main Dashboard Content */}
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={setActiveTab}
          items={[
            {
              key: '1',
              label: (
                <span>
                  <DashboardOutlined />
                  Overview
                </span>
              ),
              children: (
                <React.Suspense fallback={<Spin />}>
                  <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Ride Status"
                        //  loading={loading}
                        extra={
                          <Tooltip title="Ride status distribution across all rides">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >

                        <div style={{ height: chartDimensions.height }}>
                          <StatusPieChart
                            data={Object.entries(processedData.statusCounts).map(([status, count]) => ({
                              label: statusLabel[status],
                              value: count,
                              color: statusColors[status] || '#d9d9d9'
                            }))}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onSegmentClick={(segment) => {
                              //  setSelectedStatus(segment.label);
                              //  setActiveTab('3'); // Switch to performance tab
                            }}
                          />
                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Utilization"
                        //  loading={loading}
                        extra={
                          <Tooltip title="utilization trends over time">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          <MonthlyTrendChart
                            data={processedData.monthlyTrends}
                            xField="month"
                            yFields={rideStatuses}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                          />
                        </div>
                      </Card>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Vehicle Types"
                        //  loading={loading}
                        extra={
                          <Tooltip title="Vehicle types distribution across rides">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>

                          <StatusPieChart
                            data={Object.entries(processedData.vehicleTypeCounts).map(([status, count]) => ({
                              label: VEHICLE_TYPES_LABEL[status],
                              key: status,
                              value: count,
                              color: vehicleTypesColors[status.trim()] || '#d9d9d9'
                            }))}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onSegmentClick={(segment) => {
                              // setSelectedVehicleType(segment.label);
                              //setActiveTab('3'); // Switch to performance tab
                            }}


                          // <VehicleTypeChart 
                          //   data={Object.entries(processedData.vehicleTypeCounts).map(([type, count]) => ({
                          //     label: type,
                          //     value: count
                          //   }))}
                          //   width={chartDimensions.width}
                          //   height={chartDimensions.height}
                          //   onSegmentClick={(segment) => {
                          //     setSelectedVehicleType(segment.label);
                          //   }}
                          />
                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Card
                        title=" User Activity (Health Partners)"
                        //   loading={loading}
                        extra={
                          <Tooltip title="•	Total HO team members who have scheduled rides">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          <div style={{ fontWeight: 500, marginBottom: 8 }}>
                            Total: {processedData?.rawData?.length}
                          </div>
                          <StatusPieChart
                            data={Object.entries(processedData?.hoActivityCounts || {}).map(([label, count]) => ({
                              label: label,
                              key: label,
                              value: count,
                              color: stringToColor[label.trim()] || '#d9d9d9'
                            }))}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onSegmentClick={(segment) => {
                              // setSelectedStatus(segment.label);
                              //  setActiveTab('3'); // Switch to performance tab
                            }}
                          />
                        </div>
                      </Card>
                    </Col>
                  </Row>
                </React.Suspense>
              )
            },
            {
              key: '2',
              label: (
                <span>
                  <DashboardOutlined />
                  Access
                </span>
              ),
              children: (
                <React.Suspense fallback={<Spin />}>
                  <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Rider Metrics"
                        //  loading={loading}
                        extra={

                          <Tooltip title={
                            <>
                              <div><strong>Mobility Indicators</strong></div>
                              <div>- No shows &gt; 5 within 90 days</div>
                              <div>- Cancellations &gt; 5 within 90 days</div>
                              <div>- Rider Age &gt; 70</div>
                              <div>- Rider Weight &gt; 300 lbs</div>
                            </>
                          }>
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >

                        <div style={{ height: chartDimensions.height }}>

                          {/* <MonthlyTrendChart
                            data={processedData.monthlyPatientTrends}
                            xField="month"
                            yFields={[{
                              key: 'allPatients', label: 'All Patients', color: '#1890ff'
                            },
                            { key: 'specialAccommodations', label: 'Special Accommodations', color: '#ff4d4f' },

                            ]}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                          /> */}

                          <BarChart
                            data={processedData.monthlyPatientTrends}
                            xField="month"
                            yFields={[{
                              key: 'allPatients', label: 'All Patients', color: '#1890ff'
                            },
                            { key: 'specialAccommodations', label: 'Mobility Indicators', color: '#ff4d4f' },

                            ]}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onBarClick={(data) => {

                            }} />

                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Risk Analysis"
                        //  loading={loading}
                        extra={
                          <Tooltip title="All patients' vs Mobility Indicators vs  Frequent Riders">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          {/* <MonthlyTrendChart
                            data={processedData.monthlyPatientTrends}
                            xField="month"
                            yFields=
                            {[{
                              key: 'riderNoShow', label: 'Rider No Show', color: '#1890ff'
                            },
                            { key: 'specialAccommodations', label: 'Special Accommodations', color: '#ff4d4f' },

                            { key: 'frequentScheduled', label: ' Frequent Riders', color: '#52c41a' }
                            ]}

                            width={chartDimensions.width}
                            height={chartDimensions.height}
                          /> */}

                          <BarChart
                            data={processedData.monthlyPatientTrends}
                            xField="month"
                            yFields=
                            {[{
                              key: 'riderNoShow', label: 'Rider No Show', color: '#1890ff'
                            },
                            { key: 'specialAccommodations', label: 'Mobility Indicators', color: '#ff4d4f' },

                            { key: 'frequentScheduled', label: 'Frequent Riders', color: '#52c41a' }
                            ]}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onBarClick={(data) => {

                            }} />
                        </div>
                      </Card>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Rider Outreach (Rural rides vs Non rural rides)"
                        //  loading={loading}
                        extra={
                          <Tooltip title="Rider Outreach (Rural rides vs Non rural rides)">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          {/* <MonthlyTrendChart
                            data={processedData.monthlyPatientTrends}
                            xField="month"
                            yFields={rideDistanceCategories}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                          /> */}


                          <BarChart
                            data={processedData.monthlyPatientTrends}
                            xField="month"
                            yFields={rideDistanceCategories}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onBarClick={(data) => {

                            }} />
                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      {/* <Card 
                        title="Time Metrics" 
                     //   loading={loading}
                        extra={
                          <Tooltip title="Response, load, and ride duration metrics">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          <TimeMetricsChart 
                            data={processedData.timeMetrics}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                          />
                        </div>
                      </Card> */}
                    </Col>
                  </Row>
                </React.Suspense>
              )
            },
            {
              key: '3',
              label: (
                <span>
                  <TableOutlined />
                  Detailed View
                </span>
              ),
              children: (
                <Card
                  title="Ride Details"
                  //  loading={loading}
                  extra={
                    <Space>
                      <span>
                        Showing {ridesData.length} rides
                      </span>
                      <Button
                        size="small"
                        onClick={() => {
                          setSelectedStatus('all');
                          setSelectedOrg('all');
                          setSelectedTransport('all');
                          setSelectedVehicleType('all');
                          setSelectedDriver('all');
                        }}
                      >
                        Clear Filters
                      </Button>
                    </Space>
                  }
                >
                  <Table
                    dataSource={ridesData}
                    rowKey="id"
                    scroll={{ x: true }}
                    pagination={{
                      pageSize: 10,
                      showSizeChanger: true,
                      pageSizeOptions: ['10', '25', '50', '100']
                    }}
                    onRow={(record) => ({
                      onClick: () => showRideDetails(record)
                    })}
                    columns={[
                      {
                        title: 'Ride ID',
                        dataIndex: 'seqId',
                        key: 'seqId',
                        sorter: (a, b) => a.seqId.localeCompare(b.seqId),
                        fixed: 'left'
                      },
                      {
                        title: 'Status',
                        dataIndex: 'status',
                        key: 'status',
                        filters: statusOptions.filter(opt => opt.value !== 'all'),
                        onFilter: (value, record) => record.status === value,
                        sorter: (a, b) => a.status.localeCompare(b.status),
                        render: status => (
                          <Badge
                            color={statusColors[status] || '#d9d9d9'}
                            text={status}
                          />
                        )
                      },
                      {
                        title: 'Pickup Date',
                        dataIndex: 'pickUpDate',
                        key: 'pickUpDate',
                        render: date => dayjs(date).format('MMM D, YYYY h:mm A'),
                        sorter: (a, b) => new Date(a.pickUpDate) - new Date(b.pickUpDate)
                      },
                      {
                        title: 'Vehicle Type',
                        dataIndex: 'vehicleType',
                        key: 'vehicleType',
                        filters: vehicleTypeOptions.filter(opt => opt.value !== 'all'),
                        onFilter: (value, record) => record.vehicleType === value
                      },
                      {
                        title: 'Organization',
                        dataIndex: 'healthOrganizationId',
                        key: 'healthOrganizationId',
                        render: id => healthOrganizations.find(o => o.id === id)?.name || `Org ${id}`
                      },
                      {
                        title: 'Transport Co.',
                        dataIndex: 'transportCompanyId',
                        key: 'transportCompanyId',
                        render: id => transportCompanies.find(t => t.id === id)?.name || `Co. ${id}`
                      },
                      {
                        title: 'Driver',
                        dataIndex: 'driverId',
                        key: 'driverId',
                        render: id => id ? drivers.find(d => d.id === id)?.name || `Driver ${id}` : 'Not assigned'
                      },
                      {
                        title: 'Mileage',
                        dataIndex: 'actMileage',
                        key: 'actMileage',
                        render: mileage => mileage ? `${mileage} miles` : 'N/A'
                      },
                      {
                        title: 'Actions',
                        key: 'actions',
                        fixed: 'right',
                        render: (_, record) => (
                          <Button
                            type="link"
                            onClick={(e) => {
                              e.stopPropagation();
                              showRideDetails(record);
                            }}
                          >
                            Details
                          </Button>
                        )
                      }
                    ]}
                  />
                </Card>
              )
            },
            {
              key: '4',
              label: (
                <span>
                  <LineChartOutlined />
                  TC Performance
                </span>
              ),
              children: (
                <React.Suspense fallback={<Spin />}>
                  <Row gutter={[16, 16]}>
                    {/* <Col xs={24}>
                      <Card 
                        title="Organization Performance" 
                       // loading={loading}
                        extra={
                          <Tooltip title="Click on bars to filter by organization">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height+100 }}>
                          <BarChart 
                            data={processedData.orgPerformance}
                            xField="org"
                            yFields={['COMPLETED', 'EXPIRED', 'CANCELED','UNABLE_TO_FULFILL', 'PENDING']}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                            height={chartDimensions.height}
                            onBarClick={(data) => {
                              const orgId = healthOrganizations.find(o => o.name === data.org)?.id;
                              if (orgId) {
                                setSelectedOrg(orgId);
                                setActiveTab('2'); // Switch to detailed view
                              }
                            }}
                          />
                        </div>
                      </Card>
                    </Col> */}
                    <Col xs={24}>
                      <Card
                        title="Account Activity"
                        // loading={loading}
                        extra={
                          <Tooltip title="Activity by transport company">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height + 100 }}>
                          <BarChart
                            data={processedData.transportPerformance}
                            xField="company"
                            yFields={TcStatus}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                            height={chartDimensions.height}
                            onBarClick={(data) => {
                              const tcId = transportCompanies.find(t => t.name === data.company)?.id;
                              if (tcId) {

                              }
                            }}
                          />
                        </div>
                      </Card>
                    </Col>

                    <Col xs={24}>
                      <Card
                        title="Location Map"
                        // loading={loading}
                        extra={
                          <Tooltip title="Location distribution by county based on pickup address">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height + 100 }}>
                          <RidesByCountyChart
                            data={ridesData}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                          />


                        </div>
                      </Card>
                    </Col>

                    {/* <Col xs={24}>
                      <Card
                        title="Performance"
                        // loading={loading}
                        extra={
                          <Tooltip title="Click on bars to filter by transport company">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height + 100 }}>
                          <BarChart
                            data={processedData.transportPerformance}
                            xField="company"
                            yFields={['COMPLETED', 'FAILED']}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                            height={chartDimensions.height}
                            onBarClick={(data) => {
                              const tcId = transportCompanies.find(t => t.name === data.company)?.id;
                              if (tcId) {
                                setSelectedTransport(tcId);
                                setActiveTab('2'); // Switch to detailed view
                              }
                            }}
                          />
                        </div>
                      </Card>
                    </Col> */}

                    {/* <Col xs={24}>
                      <Card
                        title="Driver Performance"
                      //  loading={loading}
                      >
                        <div style={{ height: chartDimensions.height }}>
                          <DriverPerformanceChart
                            data={processedData.driverPerformance}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                            height={chartDimensions.height}
                          />
                        </div>
                      </Card>
                    </Col> */}


                  </Row>
                </React.Suspense>
              )
            },
            {
              key: '6',
              label: (
                <span>
                  <HeatMapOutlined />
                  Geo Insights
                </span>
              ),
              children: (
                <React.Suspense fallback={<Spin />}>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>

                      <Card
                        title="Geographic Insights for HO "
                        //   loading={loading}
                        extra={
                          <Tooltip title="Shows ride distribution by county based on pickup address">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: 400 }}>
                          <RidesByCountyChart
                            data={ridesData}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                          />
                        </div>
                      </Card>
                    </Col>
                  </Row>
                </React.Suspense>
              )
            },
            {
              key: '5',
              label: (
                <span>
                  <HeatMapOutlined />
                  Cancellations
                </span>
              ),
              children: (
                <React.Suspense fallback={<Spin />}>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>

                    <Col xs={24} lg={12}>
                      <Card
                        title="Cancellation Reasons – Riders"
                        //   loading={loading}
                        extra={
                          <Tooltip title="Cancellation reasons by riders">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: 400 }}>
                          {!processedData.cancellationData?.RIDER || Object.keys(processedData.cancellationData?.RIDER || {}).length === 0 ? (
                            <div style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                              color: 'rgba(0, 0, 0, 0.45)',
                              fontSize: '16px'
                            }}>
                              No records found
                            </div>
                          ) : (
                            <DonutChartWithCenterTotal
                              data={Object.entries(processedData.cancellationData?.RIDER || {}).map(([_, obj]) => ({
                                label: obj.reason,
                                value: obj.count
                              }))}
                              name="Rider Cancellations"
                              width={chartDimensions.width}
                              height={chartDimensions.height}
                              onSegmentClick={(segment) => {
                                //setSelectedVehicleType(segment.label);
                              }}

                            />)}
                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Canceled vs. Rescheduled Rides"
                        //  loading={loading}
                        extra={
                          <Tooltip title="Shows monthly trends of canceled vs rescheduled rides">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          {/* <MonthlyTrendChart
                            data={processedData.monthlyTrends}
                            xField="month"
                            yFields={rideReschduleCancellation}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                          /> */}

                          <BarChart
                            data={processedData.monthlyTrends}
                            xField="month"
                            yFields={rideReschduleCancellation}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onBarClick={(data) => {

                            }}
                          />

                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Cancellation Reasons – HO Team"
                        //  loading={loading}
                        extra={
                          <Tooltip title="Cancellation reasons by health organization team">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          {!processedData.cancellationData?.RIDER || Object.keys(processedData.cancellationData?.HO_ADMIN || {}).length === 0 ? (
                            <div style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                              color: 'rgba(0, 0, 0, 0.45)',
                              fontSize: '16px'
                            }}>
                              No records found
                            </div>
                          ) : (

                            <DonutChartWithCenterTotal
                              data={Object.entries(processedData.cancellationData?.HO_ADMIN || {}).map(([_, obj]) => ({
                                label: obj.reason,
                                value: obj.count
                              }))}
                              name="HO Team Cancellations"
                              width={chartDimensions.width}
                              height={chartDimensions.height}
                              onSegmentClick={(segment) => {
                                //setSelectedVehicleType(segment.label);
                              }}

                            />)}

                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Cancellation Reasons – TCs"
                        //  loading={loading}
                        extra={
                          <Tooltip title="Cancellation reasons by transport companies">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>

                          {!processedData.cancellationData?.TC_ADMIN || Object.keys(processedData.cancellationData?.TC_ADMIN || {}).length === 0 ? (
                            <div style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                              color: 'rgba(0, 0, 0, 0.45)',
                              fontSize: '16px'
                            }}>
                              No records found
                            </div>
                          ) : (
                            <DonutChartWithCenterTotal
                              data={Object.entries(processedData.cancellationData?.TC_ADMIN || {}).map(([_, obj]) => ({
                                label: obj.reason,
                                value: obj.count
                              }))}
                              name='TC Cancellations'
                              width={chartDimensions.width}
                              height={chartDimensions.height}
                              onSegmentClick={(segment) => {
                                //setSelectedVehicleType(segment.label);
                              }}

                            />)}

                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Cancellation Reasons – Drivers"
                        //  loading={loading}
                        extra={
                          <Tooltip title="Cancellation reasons by drivers">
                            <InfoCircleOutlined />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          {!processedData.cancellationData?.DRIVER || Object.keys(processedData.cancellationData?.DRIVER || {}).length === 0 ? (
                            <div style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                              color: 'rgba(0, 0, 0, 0.45)',
                              fontSize: '16px'
                            }}>
                              No records found
                            </div>
                          ) : (

                            <DonutChartWithCenterTotal
                              data={Object.entries(processedData.cancellationData?.DRIVER || {}).map(([_, obj]) => ({
                                label: obj.reason,
                                value: obj.count
                              }))}
                              name="Driver Cancellations"
                              width={chartDimensions.width}
                              height={chartDimensions.height}
                              onSegmentClick={(segment) => {
                                //setSelectedVehicleType(segment.label);
                              }}

                            />)}
                        </div>
                      </Card>
                    </Col>


                  </Row>
                </React.Suspense>
              )
            },



            {
              key: '7',
              label: (
                <span>
                  <FilePdfOutlined />
                  Reports
                </span>
              ),
              children: (
                <ReportsSection
                  organizations={healthOrganizations}
                  transportCompanies={transportCompanies}
                  dateRange={dateRange}
                  exportReport={exportReport}
                // loading={loading}
                />
              )
            }


          ]}
        />

        {/* Ride Details Modal */}
        <Modal
          title={`Ride Details: ${selectedRide?.seqId || ''}`}
          visible={rideModalVisible}
          onCancel={() => setRideModalVisible(false)}
          footer={null}
          width={800}
        >
          {selectedRide && (
            <div>
              <Row gutter={16}>
                <Col span={12}>
                  <Card title="Basic Information" size="small">
                    <p><strong>Status:</strong> <Badge color={statusColors[selectedRide.status]} text={selectedRide.status} /></p>
                    <p><strong>Vehicle Type:</strong> {selectedRide.vehicleType || 'N/A'}</p>
                    <p><strong>Pickup Date:</strong> {dayjs(selectedRide.pickUpDate).format('MMM D, YYYY h:mm A')}</p>
                    <p><strong>Appointment Date:</strong> {selectedRide.appointmentDate ? dayjs(selectedRide.appointmentDate).format('MMM D, YYYY h:mm A') : 'N/A'}</p>
                    <p><strong>Is Recurring:</strong> {selectedRide.isRecurring ? 'Yes' : 'No'}</p>
                    {selectedRide.isRecurring && (
                      <p><strong>Recurrence Index:</strong> {selectedRide.recurrenceIndex}</p>
                    )}
                  </Card>
                </Col>
                <Col span={12}>
                  <Card title="Parties Involved" size="small">
                    <p><strong>Health Organization:</strong> {healthOrganizations.find(o => o.id === selectedRide.healthOrganizationId)?.name || `Org ${selectedRide.healthOrganizationId}`}</p>
                    <p><strong>Transport Company:</strong> {transportCompanies.find(t => t.id === selectedRide.transportCompanyId)?.name || `Co. ${selectedRide.transportCompanyId}`}</p>
                    <p><strong>Driver:</strong> {selectedRide.driverId ? drivers.find(d => d.id === selectedRide.driverId)?.name || `Driver ${selectedRide.driverId}` : 'Not assigned'}</p>
                    <p><strong>Created By:</strong> User {selectedRide.createdById}</p>
                  </Card>
                </Col>
              </Row>
              <Row gutter={16} style={{ marginTop: 16 }}>
                <Col span={12}>
                  <Card title="Timeline Metrics" size="small">
                    <p><strong>Created At:</strong> {dayjs(selectedRide.createdAt).format('MMM D, YYYY h:mm A')}</p>
                    <p><strong>Accepted At:</strong> {selectedRide.acceptanceTime ? dayjs(selectedRide.acceptanceTime).format('MMM D, YYYY h:mm A') : 'N/A'}</p>
                    <p><strong>Actual Pickup:</strong> {selectedRide.actualPickUpDate ? dayjs(selectedRide.actualPickUpDate).format('MMM D, YYYY h:mm A') : 'N/A'}</p>
                    <p><strong>Completed At:</strong> {selectedRide.unloadTime ? dayjs(selectedRide.unloadTime).format('MMM D, YYYY h:mm A') : 'N/A'}</p>
                    {selectedRide.waitTime && (
                      <p><strong>Wait Time:</strong> {selectedRide.waitTime} minutes</p>
                    )}
                  </Card>
                </Col>
                <Col span={12}>
                  <Card title="Additional Information" size="small">
                    <p><strong>Pickup Address:</strong> {selectedRide.pickupAddressDetails?.formattedAddress || 'N/A'}</p>
                    <p><strong>Destination:</strong> {selectedRide.destinationAddressDetails?.formattedAddress || 'N/A'}</p>
                    {selectedRide.flightInfo && (
                      <p><strong>Flight Info:</strong> {selectedRide.flightInfo}</p>
                    )}
                    <p><strong>Mileage:</strong> {selectedRide.actMileage ? `${selectedRide.actMileage} miles` : 'N/A'}</p>
                    {selectedRide.rideNotes && (
                      <p><strong>Notes:</strong> {selectedRide.rideNotes}</p>
                    )}
                  </Card>
                </Col>
              </Row>
            </div>
          )}
        </Modal>
      </Content>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  healthOrganizations: state.healthOrganizations.healthOrganizations,
  transportCompanies: state.transportOrganizations.transportOrganizations,
  drivers: state.transportOrganizations.drivers,
  //loading: state.rides.loading,
  ridesData: state.rides.reportingRides,
  summary: state.rides.reportingSummary,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAllTransportOrganizations,
      fetchTCDrivers,
      fetchAllHealthOrganizations,
      resetDrivers,
      getReportingRides,
      exportReport,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(MH_Reporting_Dashboard);